export const environment = {
  production: true,
  apiUrl: 'https://hom-apisicred.amc.fortaleza.ce.gov.br',
  envName: 'homolog'
};
